module.exports = __webpack_public_path__ + "img/electricalMoto_EN.jpg";